var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJunoPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4643EE",
    d: "M0 0h128v128H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.078 101.524c-4.621 0-16.415-1.105-26.273-10.768-10.428-10.218-11.288-23.107-11.305-26.8v-.03c.065-4.615 1.26-16.4 11-26.213 9.853-9.925 21.746-11.142 26.415-11.213h.024a1.853 1.853 0 0 1 1.855 1.852v8.053a1.852 1.852 0 0 1-1.845 1.852c-2.555 0-11.438.605-18.427 7.815-6.504 6.711-7.231 14.717-7.245 17.846.02 3.018.724 10.8 6.796 17.422 7.051 7.672 16.328 8.345 19.005 8.369 2.559 0 11.53-.601 18.546-7.917 6.456-6.711 7.16-14.697 7.167-17.82v-35.45a1.855 1.855 0 0 1 1.855-1.855h8.002a1.854 1.854 0 0 1 1.852 1.855v35.563c0 3.677-.816 16.456-11.142 26.647-9.84 9.725-21.659 10.792-26.28 10.792zm-33.87-37.565c0 3.36.805 14.951 10.193 24.15 8.89 8.712 19.525 9.69 23.684 9.708 3.242 0 14.557-.714 23.687-9.725 9.3-9.175 10.034-20.697 10.038-24.01V30.374h-4.295v33.623c0 3.574-.83 12.701-8.2 20.387-8.032 8.366-18.284 9.046-21.233 9.056-3.076-.027-13.664-.795-21.724-9.565-6.962-7.574-7.764-16.46-7.788-19.93 0-3.598.846-12.748 8.288-20.431 6.758-6.976 15.056-8.546 19.229-8.87V30.31c-4.625.37-14.129 2.127-21.954 10.014-8.777 8.845-9.865 19.463-9.926 23.636z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.074 85.11a21.112 21.112 0 1 1 21.112-21.112 21.135 21.135 0 0 1-21.112 21.111zm0-38.513a17.405 17.405 0 1 0 17.405 17.4 17.418 17.418 0 0 0-17.405-17.4z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJunoPay);
export default __webpack_public_path__ + "static/media/junoPay.c05866599fe839532cacdcc2e80fcca8.svg";
export { ForwardRef as ReactComponent };